module.exports = __webpack_public_path__ + "img/Bodice-Front-B5-Jb.f498ffc7.png";